import { Icon } from '@iconify/react'
import { useEffect, useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import type { TestStatusResponse } from '../api'
import { getTestStatus } from '../api'

const navItems = [
  { to: '/panel', label: 'Data', icon: 'mdi:database' },
  { to: '/query', label: 'Query', icon: 'mdi:code-tags' },
  { to: '/admin', label: 'Admin', icon: 'mdi:shield-account' },
  { to: '/changelog', label: 'Changelog', icon: 'mdi:clipboard-list-outline' },
]

function TestStatusBadge() {
  const [status, setStatus] = useState<TestStatusResponse | null>(null)

  useEffect(() => {
    getTestStatus().then(setStatus).catch(() => setStatus(null))
  }, [])

  const dotColor =
    status?.status === 'pass'
      ? 'bg-green-500'
      : status?.status === 'fail' || status?.status === 'error'
        ? 'bg-red-500'
        : 'bg-slate-600'

  const label =
    status?.status === 'pass'
      ? `${status.summary.passed}/${status.summary.total} passed`
      : status?.status === 'fail'
        ? `${status.summary.failed} failed`
        : status?.status === 'error'
          ? 'error'
          : 'no results'

  if (!status) return null

  return (
    <div className="mt-auto flex items-center gap-2 px-3 pt-4" title={`Tests: ${label}`}>
      <span className={`inline-block h-2 w-2 rounded-full ${dotColor}`} />
      <span className="text-[11px] text-slate-500">{label}</span>
    </div>
  )
}

export function Layout() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="mx-auto flex max-w-7xl p-4">
        {/* Sidebar */}
        <nav className="mr-6 flex w-48 shrink-0 flex-col gap-1">
          <div className="mb-4 px-3 text-lg font-semibold text-white">MyScope</div>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 text-sm ${
                  isActive
                    ? 'bg-cyan-600/20 text-cyan-300'
                    : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'
                }`
              }
            >
              <Icon icon={item.icon} width="18" height="18" />
              {item.label}
            </NavLink>
          ))}
          <TestStatusBadge />
        </nav>

        {/* Content */}
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
